/* Naguirre — convite do Grupo VIP do WhatsApp (leva E, 14/10/2026). Carregado por snippets/ng-vip.liquid, só nas
   páginas marcadas em Configurações do tema → "Naguirre — convite do Grupo VIP". Sem biblioteca, sem imagem.
   - Aparece depois do atraso (contado do início da carga da página, como o Shopify Forms), e nunca por cima da gaveta,
     de outro modal aberto ou do chat do Jivo aberto: espera fechar. Com a aba escondida, espera ela voltar. Se a
     cliente abre o chat com o convite na tela (o botão do Jivo fica por cima do fundo escuro), o convite fecha como
     "fora" (o toque foi fora da caixa) e não briga com o chat pelo foco.
   - Fecha com o X, com Esc e tocando fora da caixa. Enquanto aberto, o foco fica preso na caixa; ao fechar, volta para
     onde estava. Não trava a rolagem (nada se desloca): o fundo só não aceita gesto (touch-action:none).
   - Frequência (localStorage ngVipConvite, com reserva no sessionStorage): fechou = volta depois dos dias do editor;
     tocou no botão = não volta mais neste navegador.
   - Medição SÓ no Ledger (regra do dono): window.ngMedir de assets/naguirre-medicao.js, eventos vip_visto, vip_tocado e
     vip_fechado (contrato em selos-vip/CONTRATO-VIP.md). Nada de Lead na Meta, nada no GA4: aqui não há fbq, gtag,
     dataLayer, Shopify.analytics.publish nem <form>. Sem ngMedir (medição desligada no editor), funciona igual, sem medir.
   - O botão é um elemento com role="link" (não <a href>, não <button>) e o grupo abre por window.open aqui. Motivo (teste com
     o código real dos pixels, 14/10): <a href> externo vira "click" de saída no GA4 e SubscribedButtonClick na Meta;
     <button>/role="button" viram SubscribedButtonClick. Enter e Espaço também abrem (teclado).
   - No editor de temas aparece 1,5 s depois de cada carga, sem gravar nada e sem medir (para conferir o texto). */
(function () {
  'use strict';
  var w = window, d = document;
  var cfg = w.ngVip;
  if (!cfg || w.__ngVipV1 || !d.querySelector || typeof d.addEventListener !== 'function') return;
  w.__ngVipV1 = true;
  var modelo = d.getElementById('ng-vip-modelo');
  if (!modelo || !('content' in modelo)) return;

  var CHAVE = 'ngVipConvite';
  var DIA = 86400000;
  var editor = cfg.editor === true;
  var atraso = Math.max(0, Math.min(600, parseInt(cfg.atraso, 10) || 0));
  var dias = Math.max(1, Math.min(365, parseInt(cfg.dias, 10) || 7));

  // ---------- Frequência ----------
  function ler() {
    var v = null;
    try { v = w.localStorage.getItem(CHAVE); } catch (e) {}
    if (v == null) { try { v = w.sessionStorage.getItem(CHAVE); } catch (e) {} }
    try { v = JSON.parse(v || 'null'); } catch (e) { v = null; }
    return v && typeof v === 'object' ? v : null;
  }
  function gravar(valor) {
    if (editor) return;
    var s = JSON.stringify(valor);
    try { w.localStorage.setItem(CHAVE, s); return; } catch (e) {}
    try { w.sessionStorage.setItem(CHAVE, s); } catch (e) {}
  }
  var marca = editor ? null : ler();
  if (marca && marca.tocado) return;
  var fechadoEm = marca && typeof marca.fechado === 'number' ? marca.fechado : 0;
  if (fechadoEm && Date.now() - fechadoEm < dias * DIA && Date.now() >= fechadoEm) return;
  var retorno = fechadoEm > 0;

  // ---------- Medição (só Ledger) ----------
  function medir(nome, campos) {
    if (editor) return;
    try { if (typeof w.ngMedir === 'function') w.ngMedir(nome, campos); } catch (e) {}
  }
  function agora() { try { return w.performance.now(); } catch (e) { return Date.now(); } }

  // ---------- Algo aberto? (gaveta, menu, busca, visualização rápida, outro modal) ----------
  // As classes que o tema (Halo) põe no <body> quando abre gaveta, menu, busca ou pop-up: "*-show" (cart-sidebar-show,
  // quick-view-show, auth-popup-show…), "*open*" (menu_open, open_search_mobile, toolbar-modal-open…), o overflow-hidden
  // e o carregador. Mais qualquer <dialog> aberto e qualquer aria-modal visível dentro da tela.
  var CLASSES = /(^|\s)([\w-]+-show|[\w-]*open[\w-]*|overflow-hidden(-mobile)?|has-halo-loader)(?=\s|$)/;
  function algoAberto() {
    try {
      if (CLASSES.test(d.body.className || '') || CLASSES.test(d.documentElement.className || '')) return true;
      if (d.querySelector('dialog[open]')) return true;
      var ms = d.querySelectorAll('[aria-modal="true"]');
      var vw = w.innerWidth || 0, vh = w.innerHeight || 0;
      for (var i = 0; i < ms.length; i++) {
        var r = ms[i].getBoundingClientRect();
        if (r.width < 2 || r.height < 2 || r.right <= 0 || r.bottom <= 0 || r.left >= vw || r.top >= vh) continue;
        var cs = w.getComputedStyle(ms[i]);
        if (cs.visibility !== 'hidden' && cs.display !== 'none' && parseFloat(cs.opacity) > 0.05) return true;
      }
      var ativo = d.activeElement;
      if (ativo && ativo !== d.body && (ativo.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(ativo.tagName))) return true;
    } catch (e) {}
    return false;
  }

  // ---------- Chat do Jivo aberto? ----------
  // O Jivo carrega com a página parada (layout/theme.liquid), quase sempre depois deste arquivo. Sinais, nesta ordem:
  // 1) as chamadas do próprio Jivo, encadeadas com quem já as tiver definido: jivo_onOpen / jivo_onClose e
  //    jivo_onChangeState ('chat' ou 'call…' = janela aberta; 'label' = só o botão). Medido na bancada (14/10):
  //    abrir = onOpen + onChangeState('chat'); fechar = onClose + onChangeState('label').
  // 2) reserva pelo DOM, enquanto nenhuma chamada chegou: no celular a janela cheia põe "jivo-site-full-block" no
  //    <html>. (O #jivo_close_button NÃO serve: no computador ele existe com o chat fechado.)
  var jivo = { aberto: false, sinal: false };
  function jivoMudou(aberto) {
    jivo.sinal = true;
    jivo.aberto = aberto;
    if (aberto && raiz) fechar('fora', true);
  }
  function encadear(nome, fn) {
    var antigo = w[nome];
    if (antigo && antigo.__ngVip) return;
    var novo = function () {
      try { fn.apply(this, arguments); } catch (e) {}
      if (typeof antigo === 'function') return antigo.apply(this, arguments);
    };
    novo.__ngVip = true;
    try { w[nome] = novo; } catch (e) {}
  }
  if (!editor) {
    encadear('jivo_onOpen', function () { jivoMudou(true); });
    encadear('jivo_onClose', function () { jivoMudou(false); });
    encadear('jivo_onChangeState', function (estado) {
      var s = String(estado || '');
      if (/^(chat|call)/.test(s)) jivoMudou(true);
      else if (s === 'label') jivoMudou(false);
    });
  }
  function jivoAberto() {
    if (jivo.sinal) return jivo.aberto;
    try {
      if (/(^|\s)jivo-site-full-block(\s|$)/.test(d.documentElement.className || '')) return true;
    } catch (e) {}
    return false;
  }
  function ehDoJivo(el) {
    try { return !!(el && el.closest && el.closest('jdiv, #jivo-iframe-container')); } catch (e) { return false; }
  }

  // ---------- Mostrar ----------
  var raiz = null, caixa = null, antes = null, abertoEm = 0, esperou = false, vigia = 0;
  function focaveis() {
    return caixa ? Array.prototype.slice.call(caixa.querySelectorAll('a[href],button:not([disabled]),[data-ng-vip-botao]')) : [];
  }
  function fechar(como, semFoco) {
    if (!raiz) return;
    var ms = Math.min(3600000, Math.max(0, Math.round(agora() - abertoEm)));
    if (como !== 'botao') {
      gravar({ fechado: Date.now() });
      medir('vip_fechado', { como: como, atraso: atraso, ms: ms, retorno: retorno });
    }
    d.removeEventListener('keydown', teclado, true);
    d.removeEventListener('focusin', focoFora, true);
    var r = raiz;
    raiz = null; caixa = null;
    r.classList.remove('is-aberto');
    setTimeout(function () { if (r.parentNode) r.parentNode.removeChild(r); }, 220);
    if (semFoco) return; // o chat do Jivo abriu: o foco é dele
    try { if (antes && antes.focus && d.contains(antes)) antes.focus({ preventScroll: true }); } catch (e) {}
  }
  // Abre o grupo numa nova aba, no próprio gesto da cliente. Sem 'noopener' nos recursos de propósito: assim o
  // window.open devolve a janela (e o opener é cortado logo em seguida); se vier null (bloqueio de pop-up ou navegador
  // dentro de app sem abas), abre na mesma aba, para o toque nunca ficar sem efeito.
  function abrirGrupo(link) {
    var j = null;
    try { j = w.open(link, '_blank'); } catch (e) { j = null; }
    if (j) { try { j.opener = null; } catch (e) {} return; }
    try { w.location.href = link; } catch (e) {}
  }
  function tocar(alvo) {
    var link = alvo && alvo.getAttribute('data-ng-vip-link');
    if (!raiz || !link || !/^https:\/\//i.test(link)) return;
    var ms = Math.min(3600000, Math.max(0, Math.round(agora() - abertoEm)));
    gravar({ tocado: Date.now() });
    medir('vip_tocado', { atraso: atraso, ms: ms, retorno: retorno });
    fechar('botao');
    abrirGrupo(link);
  }
  function teclado(e) {
    if (!raiz) return;
    var bt = e.target && e.target.getAttribute && e.target.getAttribute('data-ng-vip-botao') !== null ? e.target : null;
    if (bt && (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar' || e.keyCode === 13 || e.keyCode === 32)) {
      e.preventDefault(); e.stopPropagation();
      tocar(bt);
      return;
    }
    if (e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27) {
      e.preventDefault(); e.stopPropagation();
      fechar('esc');
      return;
    }
    if (e.key === 'Tab' || e.keyCode === 9) {
      var f = focaveis();
      if (!f.length) { e.preventDefault(); return; }
      var primeiro = f[0], ultimo = f[f.length - 1], ativo = d.activeElement;
      if (e.shiftKey && (ativo === primeiro || ativo === caixa || !caixa.contains(ativo))) { e.preventDefault(); ultimo.focus(); }
      else if (!e.shiftKey && (ativo === ultimo || !caixa.contains(ativo))) { e.preventDefault(); primeiro.focus(); }
    }
  }
  function focoFora(e) {
    if (raiz && caixa && !caixa.contains(e.target) && !ehDoJivo(e.target)) {
      try { caixa.focus({ preventScroll: true }); } catch (x) {}
    }
  }
  function mostrar() {
    if (raiz) return;
    var frag = d.importNode(modelo.content, true);
    var el = frag.querySelector('[data-ng-vip]');
    if (!el) return;
    antes = d.activeElement;
    raiz = el;
    caixa = el.querySelector('[role="dialog"]');
    el.addEventListener('click', function (e) {
      if (!raiz) return;
      if (e.target === raiz) { fechar('fora'); return; }
      var t = e.target && e.target.closest ? e.target : null;
      if (t && t.closest('[data-ng-vip-fechar]')) { e.preventDefault(); fechar('x'); return; }
      var bt = t && t.closest('[data-ng-vip-botao]');
      if (bt) { e.preventDefault(); tocar(bt); }
    });
    d.body.appendChild(frag);
    d.addEventListener('keydown', teclado, true);
    d.addEventListener('focusin', focoFora, true);
    abertoEm = agora();
    // 2 quadros: o estado fechado pinta antes, para a entrada suave (opacidade; nada se desloca).
    var raf = w.requestAnimationFrame || function (f) { return setTimeout(f, 16); };
    raf(function () { raf(function () { if (raiz) raiz.classList.add('is-aberto'); }); });
    try { caixa.focus({ preventScroll: true }); } catch (e) {}
    medir('vip_visto', { atraso: atraso, esperou: esperou, retorno: retorno });
  }

  // ---------- Quando ----------
  function tentar() {
    vigia = 0;
    if (raiz) return;
    if (d.hidden) { d.addEventListener('visibilitychange', quandoVisivel); return; }
    if (algoAberto() || jivoAberto()) { esperou = true; vigia = setTimeout(tentar, 1000); return; }
    mostrar();
  }
  function quandoVisivel() {
    if (d.hidden) return;
    d.removeEventListener('visibilitychange', quandoVisivel);
    if (!vigia) vigia = setTimeout(tentar, 600);
  }
  var falta = editor ? 1500 : Math.max(0, atraso * 1000 - agora());
  vigia = setTimeout(tentar, falta);
})();
